export default __webpack_public_path__ + "static/media/image.oqtave-labs.201f2fe8.png";